const _this = {

    $dom: {
		
    },

    vars: {
		
	},

    init : function() {
        this.headerSticky();
    },

    headerSticky: function() {
		$(window).scroll(function() {
			if ($(this).scrollTop() > 1) {
				$('.site-header').addClass('site-header__sticky');
			} else {
				$('.site-header').removeClass('site-header__sticky');
			}
		});
	}
}

export default _this;